function approvalMessageModal () {
  return {
    restrict: 'E',
    templateUrl: '/core/directives/approval-message-modal/approval-message-modal.html?$$REVISION$$'
  }
}
export { approvalMessageModal }
